export const CONTACT_SALES_URL_HASH = 'contact-sales';

export const apiEndpoints = {
  contactSales: `/api/v1/contact-sales`,
  jobApplication: '/api/v1/career-page',
  oauthState: '/api/v1/users/oauth/generate-state',
} as const;
